module.exports = __webpack_public_path__ + "img/linkedin-profile.989bf9a7.webp";